import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	AP_CONFIGURE_MODAL_EVENT,
	AP_CREATE_MODAL_EVENT,
	AP_DELETE_MODAL_EVENT,
	AP_MOVE_MODAL_EVENT,
	AP_RADIO_MODAL_EVENT,
	AP_REBOOT_MODAL_EVENT,
} from './events';

/**
 * Open Add Access Point.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} acknowledgement
 */
export function openAccessPointCreateModal(command, envelope) {
	return openResourceModal(AP_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Access Point configuration.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} acknowledgement
 */
export function openAccessPointConfigureModal(command, envelope) {
	return openResourceModal(AP_CONFIGURE_MODAL_EVENT, command, envelope);
}

/**
 * Open Move Access Point.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} acknowledgement
 */
export function openAccessPointMoveModal(command, envelope) {
	return openResourceModal(AP_MOVE_MODAL_EVENT, command, envelope);
}

/**
 * Open the Access Point reboot confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} acknowledgement
 */
export function openAccessPointRebootModal(command, envelope) {
	return openResourceModal(AP_REBOOT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Access Point delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} acknowledgement
 */
export function openAccessPointDeleteModal(command, envelope) {
	return openResourceModal(AP_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open the Access Point radio settings.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} acknowledgement
 */
export function openAccessPointRadioModal(command, envelope) {
	return openResourceModal(AP_RADIO_MODAL_EVENT, command, envelope);
}

/**
 * Report an Access Point modal outcome.
 * @param {string} eventType lifecycle event
 * @param {string|null} errorCode error identifier
 * @return {Promise<object|null>} response
 */
export function reportAccessPointModalLifecycle(eventType, errorCode = null) {
	return reportActiveAgentModalLifecycle(eventType, errorCode);
}
